import { getApiBaseUrl } from '../utils/apiBaseUrl';

// 환경변수 설정 파일
export const config = {
  // API 기본 URL (빈 문자열 = 브라우저 현재 출처 기준 상대 경로)
  API_BASE_URL: getApiBaseUrl(),
  
  // API 타임아웃 (밀리초)
  API_TIMEOUT: parseInt(process.env.REACT_APP_API_TIMEOUT || '10000'),
  
  // 페이지당 아이템 수
  ITEMS_PER_PAGE: parseInt(process.env.REACT_APP_ITEMS_PER_PAGE || '10'),
  
  // 개발 모드 여부
  IS_DEVELOPMENT: process.env.NODE_ENV === 'development',
  
  // 프로덕션 모드 여부
  IS_PRODUCTION: process.env.NODE_ENV === 'production',

  /** 고객 상세 IP 관리 탭: 추가·수정·비활성화 UI 숨김(API는 그대로). true = 읽기 전용 UI */
  IP_ALLOWLIST_READONLY: process.env.REACT_APP_IP_ALLOWLIST_READONLY === '1',
};

// API 엔드포인트 정의
export const API_ENDPOINTS = {
  // 대시보드 관련
  DASHBOARD: '/api/dashboard/',
  STATS: '/api/dashboard/stats',
  
  // 고객 관련
  CUSTOMERS: '/api/customers',
  CUSTOMER_DETAIL: (id: string) => `/api/customers/${id}`,
  
  // 결제 관련
  PAYMENTS: '/api/payments',
  PAYMENT_DETAIL: (id: string) => `/api/payments/${id}`,
  
  // 키워드 관련
  KEYWORDS: '/api/keywords',
  KEYWORD_DETAIL: (id: string) => `/api/keywords/${id}`,
  
  // 차트 데이터
  CHARTS: '/api/charts',
  KEYWORD_STATS: '/api/charts/keyword-stats'
}; 